module.exports = __webpack_public_path__ + "static/img/cabecera3.c381008e.jpg";